import { motion } from 'framer-motion';
import { Users, DollarSign, ShoppingCart, Dumbbell } from 'lucide-react';

export const AdminStatsCards = ({ stats, onTabChange }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-card border border-border p-6"
      >
        <div className="flex items-center justify-between mb-2">
          <Users className="h-8 w-8 text-primary" />
          <span className="text-muted-foreground text-sm">Total</span>
        </div>
        <p className="font-heading text-4xl text-white">{stats?.total_users || 0}</p>
        <p className="text-muted-foreground text-sm">Users</p>
        <p className="text-green-400 text-xs mt-1">+{stats?.recent_registrations || 0} this week</p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-card border border-border p-6"
      >
        <div className="flex items-center justify-between mb-2">
          <DollarSign className="h-8 w-8 text-green-500" />
          <span className="text-muted-foreground text-sm">Revenue</span>
        </div>
        <p className="font-heading text-4xl text-white">${(stats?.total_revenue || 0).toLocaleString()}</p>
        <p className="text-muted-foreground text-sm">Total Earned</p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        onClick={() => onTabChange?.('purchases')}
        className="bg-card border border-border p-6 cursor-pointer hover:border-primary/50 transition-colors"
        data-testid="purchases-stat-card"
      >
        <div className="flex items-center justify-between mb-2">
          <ShoppingCart className="h-8 w-8 text-blue-500" />
          <span className="text-muted-foreground text-sm">Sales</span>
        </div>
        <p className="font-heading text-4xl text-white">{stats?.total_purchases || 0}</p>
        <p className="text-muted-foreground text-sm">Purchases</p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        onClick={() => onTabChange?.('programs')}
        className="bg-card border border-border p-6 cursor-pointer hover:border-primary/50 transition-colors"
        data-testid="programs-stat-card"
      >
        <div className="flex items-center justify-between mb-2">
          <Dumbbell className="h-8 w-8 text-purple-500" />
          <span className="text-muted-foreground text-sm">Content</span>
        </div>
        <p className="font-heading text-4xl text-white">{stats?.total_programs || 0}</p>
        <p className="text-muted-foreground text-sm">Programs</p>
      </motion.div>
    </div>
  );
};
